import React from 'react';
import PropTypes from 'prop-types';
import {
    Box,
    Typography,
    Paper,
    alpha
} from '@mui/material';

const StatCard = ({
    title,
    value,
    icon,
    subtitle,
    trend,
    trendColor = '#6B7280',
    color = '#0a0068',
    elevation = 0,
    sx = {}
}) => (
    <Paper
        elevation={0}
        sx={{
            p: 2,
            border: '1px solid #E5E7EB',
            borderRadius: '8px',
            backgroundColor: 'white',
            cursor: 'pointer',
            transition: 'all 0.2s ease',
            '&:hover': {
                borderColor: '#3B82F6'
            },
            ...sx
        }}
    >
        <Box sx={{ mb: 1.5 }}>
            <Typography variant="body2" sx={{
                fontSize: '14px',
                color: '#6B7280',
                fontFamily: 'Poppins',
                fontWeight: 400
            }}>
                {title}
            </Typography>
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
            <Typography variant="h4" sx={{
                fontWeight: 700,
                fontSize: { xs: '24px', sm: '28px', md: '32px' },
                color: '#111827',
                fontFamily: 'Poppins'
            }}>
                {value}
            </Typography>
            <Box sx={{
                p: 1,
                borderRadius: '8px',
                backgroundColor: '#F3F4F6',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }}>
                {React.cloneElement(icon, {
                    sx: {
                        fontSize: 20,
                        color: '#6B7280'
                    }
                })}
            </Box>
        </Box>

        {subtitle && (
            <Typography variant="body2" sx={{
                fontSize: '12px',
                color: '#9CA3AF',
                fontFamily: 'Poppins',
                mb: 1
            }}>
                {subtitle}
            </Typography>
        )}

        {trend && (
            <Box sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 0.5,
                fontSize: '12px',
                color: trendColor,
                fontFamily: 'Poppins'
            }}>
                {trend}
            </Box>
        )}
    </Paper>
);

StatCard.propTypes = {
    title: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    icon: PropTypes.element.isRequired,
    subtitle: PropTypes.string,
    trend: PropTypes.node,
    trendColor: PropTypes.string,
    color: PropTypes.string,
    elevation: PropTypes.number,
    sx: PropTypes.object
};

export default StatCard;